import React, { useState, useEffect, useContext } from "react";
import { Typography, Input, Button, Row, Col, message, Tooltip } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { withRouter } from "react-router";
import AddMachineModal from "./AddMachineModal";
import PineLabsTable from "./PineLabsTable";
import { platformApi } from "../../../api";
import { useBranch } from "../../../ContextAPI/branch";
import { ContextAPI } from "../../../ContextAPI";

const { Title } = Typography;
const { Search } = Input;

const PineLabs = (props) => {
  const { selectBranch } = useBranch();
  const { loginCredintials } = useContext(ContextAPI);

  const [createAccess, setCreateAccess] = useState(false);
  const [modifyAccess, setModifyAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);

  const [addFlag, setAddFlag] = useState(false);
  const [editable, setEditable] = useState(false);
  const [selected, setSelected] = useState(null);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState(null);
  const [spinning, setSpinning] = useState(false);
  const [userOptions, setUserOptions] = useState([]);
  const [associatedUsers, setAssociatedUsers] = useState([]);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    getPineLabsData();
    getUserOptions();
    getAssociatedUsers();
    loginCredintials.roleAccess &&
      loginCredintials.roleAccess.map((each) => {
        if (each.subModule === "Pine Labs") {
          if (each.access.create) {
            setCreateAccess(true);
          }
          if (each.access.update) {
            setModifyAccess(true);
          }
          if (each.access.delete) {
            setDeleteAccess(true);
          }
        }
      });
  }, []);

  const getAssociatedUsers = async () => {
    try {
      const res = await platformApi.get("/api/pinelabs/associated-users");
      setAssociatedUsers(res?.data?.response?.data || []);
    } catch (err) {
      console.error("Error fetching associated users", err);
    }
  };

  const handlePageChange = (pageNum, size) => {
    setPage(pageNum);
    setPageSize(size);
    getPineLabsData(search, pageNum, size);
  };

  const getPineLabsData = async (searchString = null) => {
    setSpinning(true);
    try {
      const branchIds = (selectBranch || []).map((b) => b.id);

      const payload = {
        searchString,
        page,
        size: pageSize,
        branch: branchIds,
      };

      const res = await platformApi.post("/api/pinelabs/get", payload);
      setData(res.data.response?.data?.records || []);
    } catch (err) {
      console.error("Error fetching PineLabs data", err);
      message.error("Unable to fetch machines", 2);
    } finally {
      setSpinning(false);
    }
  };


  const getUserOptions = async () => {
    try {
      const res = await platformApi.post("/api/user/get", {
        size: 1000,
        page: 1,
      });

      const users = res?.data?.response?.data?.users || [];

      const filteredUsers = users.filter((u) => {
        // const isCashier = u?.profile?.department?.role === "Cashier";

        const userBranchIds = (u?.profile?.branch || []).map((b) => b.id);

        const selectedBranchIds = (selectBranch || []).map((b) => b.id);

        const hasMatchingBranch = userBranchIds.some((id) =>
          selectedBranchIds.includes(id)
        );

        // return isCashier && hasMatchingBranch;
        return hasMatchingBranch && u.status == true;
      });

      // format for dropdowns
      const formatted = filteredUsers.map((u) => ({
        label: u.profile.employeeName,
        value: u.id,
      }));

      setUserOptions(formatted);
    } catch (err) {
      console.error("Error fetching user options", err);
      message.error("Unable to fetch user list", 2);
    }
  };


  const openCreate = () => {
    setSelected(null);
    setEditable(true);
    setAddFlag(true);
  };

  const openEdit = (id) => {
    setSelected(id);
    setEditable(true);
    setAddFlag(true);
  };

  const openView = (id) => {
    setSelected(id);
    setEditable(false);
    setAddFlag(true);
  };

  const closeModal = () => {
    setAddFlag(false);
    setSelected(null);
    getPineLabsData();
    getAssociatedUsers();
  };

  const handleSave = async (machine) => {
    try {
      if (machine.id) {
        const res = await platformApi.put(`/api/pinelabs/update/${machine.id}`, machine);
        if (res?.data?.code === 200) {
          message.success("Machine updated successfully");
        } else {
          message.error("Unable to update machine");
        }
      } else {
        const res = await platformApi.post("/api/pinelabs/create", machine);
        if (res?.data?.code === 200) {
          message.success("Machine added successfully");
        } else {
          message.error("Unable to add machine");
        }
      }
    } catch (err) {
      console.error("Save error", err);
      message.error("Server error while saving", 2);
    } finally {
      // refresh list
      getPineLabsData();
      getAssociatedUsers();
      setAddFlag(false);
      setSelected(null);
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await platformApi.delete(`/api/pinelabs/${id}`);
      if (res?.data?.code === 200) {
        message.success("Deleted successfully");
        getPineLabsData();
        getAssociatedUsers();
      } else {
        message.error("Unable to delete");
      }
    } catch (err) {
      console.error("Delete error", err);
      message.error("Server error while deleting");
    }
  };

  const selectedData = selected ? data.find((d) => d.id === selected) : null;

  const filteredUserOptions = userOptions.filter((opt) => {
    return !associatedUsers.some(
      (au) => au.value === opt.value && (!selectedData || au.nodeId !== selectedData.id)
    );
  });

  return (
    <div className="pinelabs-root">
      <div className="pinelabs-head" style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
        <Title level={4} style={{ margin: 0, flex: 1, display: "flex", alignItems: "center" }}>
          <Tooltip placement="topLeft" title="Back to Company Master">
            <Button
              style={{ marginRight: "20px" }}
              onClick={() => props.history.push("/autoadmin/company")}
            >
              <LeftOutlined />
            </Button>
          </Tooltip>
          PineLabs Machines [{data.length}]
        </Title>

        <Search
          placeholder="Search by machineId / clientId"
          onSearch={(v) => {
            setSearch(v || null);
            getPineLabsData(v || null);
          }}
          allowClear
          style={{ width: 320 }}
        />

        <Button type="primary" disabled={!createAccess} onClick={openCreate} style={{ marginLeft: 12 }}>
          Add Machine
        </Button>
      </div>

      <PineLabsTable
        data={data}
        loading={spinning}
        openModal={(id, mode) => {
          if (mode === "edit") openEdit(id);
          else openView(id);
        }}
        deleteMachine={(id) => handleDelete(id)}
        onPageChange={handlePageChange}
        modify={modifyAccess}
        deleteAccess={deleteAccess}
      />

      {addFlag && (
        <AddMachineModal
          open={addFlag}
          close={closeModal}
          editable={editable}
          data={selectedData}
          onSave={handleSave}
          userOptions={filteredUserOptions}
          branchOptions={selectBranch}
        />
      )}
    </div>
  );
};

export default withRouter(PineLabs);
